import { baseURL, APIClient } from "./_api";

export function getImage(id, type = "small") {
  return `${baseURL}_file/${id}/${type}`;
}

export function upload(data, url) {
  let bodyFormData = new FormData();
  bodyFormData.append("file", data);
  return APIClient.post(`upload/${url}/`, bodyFormData);
}
export function finishProject(data, url, id) {
  let bodyFormData = new FormData();
  bodyFormData.append("file", data);
  return APIClient.post(`upload/${url}/${id}`, bodyFormData);
}
export function getProject(id) {
  return `${baseURL}_file/${id}`;
}
export function cropImage(data) {
  return APIClient.post(`_crop_image`, data);
}
